/**
 * @generated SignedSource<<5ad74dc6464b0b45b1b10064369492d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$data = {
  readonly fieldId: string;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewNew_fragmentRef" | "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewOld_fragmentRef" | "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading">;
  readonly " $fragmentType": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField";
};
export type ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$key = {
  readonly " $data"?: ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
    },
    {
      "kind": "FragmentSpread",
      "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewOld_fragmentRef"
    },
    {
      "kind": "FragmentSpread",
      "name": "singleSelect_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewNew_fragmentRef"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "b74bd5a87cb1cca889060a9ab642a77e";

export default node;
